const medicineProductCn = {
  breadcrumbs: {
    home: '首页',
    medicineBazar: '药品市场'
  },
  loading: '加载中...',
  labels: {
    prescriptionRequired: '需要处方',
    reviewsSuffix: '评论',
    deliveryPrefix: '配送:',
    minOrderPrefix: '最低订单:',
    perUnitPrefix: '每',
    expiry: '有效期:',
    stock: '库存:',
    inStock: '有库存',
    outOfStock: '缺货',
    availableUnitsSuffix: '可用',
    selectQuantity: '选择数量:',
    unitLabel: '单位',
    unitStrip: '条',
    unitBox: '盒',
    unitTablet: '片',
    unitBottle: '瓶',
    unitVial: '小瓶',
    unitAmpule: '安瓿',
    unitTube: '管',
    unitSachet: '小袋',
    unitInhaler: '吸入器',
    perUnitNotePrefix: '* 每',
    totalAmountPrefix: '总计:',
    addToCart: '加入购物车',
    wishlistAria: '添加到愿望清单',
    shareAria: '分享',
    descriptionTab: '描述',
    specsTab: '规格',
    reviewsTab: '评论',
    productDescriptionTitle: '药品描述',
    productSpecsTitle: '药品规格',
    customerReviewsTitle: '客户评论',
    relatedTitle: '相关药品',
  },
  messages: {
    addedToCart: '已加入购物车！',
    orderInfo: '所有药品均来自持牌药房...'
  }
};

export default medicineProductCn;
